/* Cuadra Piedreros — Nudge "Agrega tu sticker gratis" + techo de $35
 * Un solo listener delegado (sobrevive re-renders del carrito).
 * El markup + la logica mostrar/ocultar del boton vive en snippets/gorra-nudge.liquid (Liquid puro).
 * Aqui:
 *   1) al click, agrega el sticker de regalo MARCADO con la propiedad oculta _regalo:sticker
 *      (asi se distingue del sticker que un cliente compre a proposito desde el PDP) y refresca.
 *   2) TECHO $35: el sticker gratis solo vive de $6 a $34.99. Shopify no deja poner un maximo
 *      en el descuento, asi que lo forzamos desde el carrito: si la mercancia real (sin contar
 *      el sticker de regalo) llega a $35, se saca el sticker de regalo y toma el relevo la gorra
 *      (Shopify solo regala 1 producto por pedido). Un sticker COMPRADO (sin la marca) no se toca.
 */
(function () {
  'use strict';
  if (window.__cpGorraNudge) return;
  window.__cpGorraNudge = true;

  var GIFT_PROP = '_regalo';
  var GIFT_VAL = 'sticker';
  var CEILING = 3500; // centavos — de $35 pa'rriba manda la gorra, no el sticker

  async function addVariant(id) {
    if (!id || id === '0') return false;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1, properties: { _regalo: 'sticker' } }]
        })
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  // --- Techo de $35: saca el sticker de regalo si la mercancia real ya llego a $35 ---
  var enforcing = false;
  async function enforceCeiling() {
    if (enforcing) return;
    enforcing = true;
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var giftKey = null;
      var merch = 0; // mercancia SIN contar el sticker de regalo, en centavos
      (cart.items || []).forEach(function (it) {
        var props = it.properties || {};
        if (props[GIFT_PROP] === GIFT_VAL) {
          giftKey = it.key;
        } else {
          merch += (it.original_line_price || 0);
        }
      });
      if (giftKey && merch >= CEILING) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftKey, quantity: 0 })
        });
        window.location.reload();
      }
    } catch (e) {
      /* silencioso: nunca romper el carrito */
    } finally {
      enforcing = false;
    }
  }

  // Re-chequear el techo despues de cualquier cambio de carrito (incluye el drawer via AJAX,
  // que no recarga la pagina). Se envuelve fetch para ser agnostico al tema.
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { enforceCeiling(); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  // Chequeo al cargar la pagina (cubre carrito, checkout-cart y navegacion normal).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceCeiling);
  } else {
    enforceCeiling();
  }

  // --- Boton "Agregar mis stickers gratis" ---
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-cp-gorra-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    var ok = await addVariant(btn.getAttribute('data-variant'));
    if (!ok) ok = await addVariant(btn.getAttribute('data-variant-fallback'));

    if (ok) {
      btn.textContent = '✓ ¡Stickers agregados!';
      // Recargar mantiene todo consistente: los stickers entran en $0 y el nudge desaparece solo.
      setTimeout(function () { window.location.reload(); }, 500);
    } else {
      btn.textContent = 'Se agotó — inténtalo de nuevo';
      btn.disabled = false;
      delete btn.dataset.busy;
      setTimeout(function () { btn.textContent = original; }, 2500);
    }
  });
})();
